import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import { OpenTokChosenDevices, OpenTokDeviceList } from '../DeviceManager';
interface EnvironmentSettingsParams {
  chosenAudio: string;
  chosenVideo: string;
  chosenOutput: string;
  deviceList: OpenTokDeviceList;
  chosenTab?: string;
  onSave(aDevices: OpenTokChosenDevices): void;
  onRunTest(): Promise<void>;
  onSuccess(): void;
  onFailure(): void;
  onHide(): void;
}
export class EnvironmentSettingsPanel extends UIObject {
  mDiv: JQuery<any>;
  mConstructorParams: EnvironmentSettingsParams;

  constructor() {
    super();
  }

  initialize(aConstructorParams: EnvironmentSettingsParams): void {
    this.mConstructorParams = aConstructorParams;

    this.mDiv = this._getStruct();

    this.setupButtons();

    this._setupDeviceDropdowns();

    if (mLocalStorage.get('connectivity') != 'passed') {
      this._showBadConnection();
    } else {
      this._showGoodConnection();
    }
  }

  private _showBadConnection(): void {
    let badIconClasses = FontAwesomeConfigurations.ICON_SETTINGS_STATUS_BAD.split(' ');
    let goodIconClasses = FontAwesomeConfigurations.ICON_SETTINGS_STATUS_GOOD.split(' ');

    this.mDiv.find('.connection_text').addClass('error').text('Not Connected!');

    this.mDiv.find('.connection_icon')[0].classList.add('error');

    goodIconClasses.forEach(iconClass => {
      this.mDiv.find('.connection_icon')[0].classList.remove(iconClass);
    });

    badIconClasses.forEach(iconClass => {
      this.mDiv.find('.connection_icon')[0].classList.add(iconClass);
    });
  }

  private _showGoodConnection(): void {
    let badIconClasses = FontAwesomeConfigurations.ICON_SETTINGS_STATUS_BAD.split(' ');
    let goodIconClasses = FontAwesomeConfigurations.ICON_SETTINGS_STATUS_GOOD.split(' ');

    this.mDiv.find('.connection_text').removeClass('error').text('Connected');

    this.mDiv.find('.connection_icon')[0].classList.remove('error');

    badIconClasses.forEach(iconClass => {
      this.mDiv.find('.connection_icon')[0].classList.remove(iconClass);
    });

    goodIconClasses.forEach(iconClass => {
      this.mDiv.find('.connection_icon')[0].classList.add(iconClass);
    });

    this.mDiv.find('.test_result_text').html('Connection was successful!');
  }

  private _onTestCompleted(results): void {
    this.mDiv.find('.test_prompt').hide();
    this.mDiv.find('.test_progress').hide();
    this.mDiv.find('.test_results').show();

    if (results.success) {
      mLocalStorage.set('connectivity', 'passed');
      this._showGoodConnection();

      if (this.mConstructorParams.onSuccess) {
        this.mConstructorParams.onSuccess();
      }

      App.INSTANCE.appDeviceManager.getAllDevices().then(deviceList => {
        this.mConstructorParams.deviceList = deviceList;
        App.INSTANCE.appDeviceManager.setAllDevices(deviceList);
        this._setupDeviceDropdowns();
        OpentokSession.INSTANCE.getStreamManager().setStreamOptions([]);
      });
    } else {
      mLocalStorage.delete('connectivity');
      this._showBadConnection();

      if (this.mConstructorParams.onFailure) {
        this.mConstructorParams.onFailure();
      }

      //concat the failedTest.error.message

      $.each(results.failedTests, function (index, failedTest) {
        //TODO: in case we have specific ways to deal with each type of error
        switch (failedTest.error.name) {
          // disabled permissions
          case OpenTokNetworkConnectivity.ErrorNames.FAILED_TO_CREATE_LOCAL_PUBLISHER:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_CAMMIC;
            break;

          // missing devices
          case OpenTokNetworkConnectivity.ErrorNames.FAILED_TO_OBTAIN_MEDIA_DEVICES:
          case OpenTokNetworkConnectivity.ErrorNames.NO_AUDIO_CAPTURE_DEVICES:
          case OpenTokNetworkConnectivity.ErrorNames.NO_VIDEO_CAPTURE_DEVICES:
            // Display UI message about no available camera or microphone
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_NOCAM;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.QUALITY_TEST_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_POORQUALITY;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.SUBSCRIBER_GET_STATS_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_STATISTICS;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.SUBSCRIBE_TO_SESSION_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_STREAMS;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.UNSUPPORTED_BROWSER:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_BROWSER;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.PUBLISH_TO_SESSION_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.PUBLISH_TO_SESSION_NETWORK_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.PUBLISH_TO_SESSION_NOT_CONNECTED:
          case OpenTokNetworkConnectivity.ErrorNames.PUBLISH_TO_SESSION_PERMISSION_OR_TIMEOUT_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_OTHERSESSIONURLS;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.CONNECT_TO_SESSION_TOKEN_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.MISSING_OPENTOK_INSTANCE:
          case OpenTokNetworkConnectivity.ErrorNames.MISSING_SESSON_CREDENTIALS:
          case OpenTokNetworkConnectivity.ErrorNames.MISSING_SUBSCRIBER_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.INCOMPLETE_SESSON_CREDENTIALS:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_SERVERCONFIG;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.FAILED_MESSAGING_SERVER_TEST:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_MESSAGINGERROR;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.LOGGING_SERVER_CONNECTION_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.CONNECT_TO_SESSION_ID_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.CONNECT_TO_SESSION_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.CONNECTIVITY_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.NETWORK_TEST_ERROR:
          case OpenTokNetworkConnectivity.ErrorNames.CONNECT_TO_SESSION_NETWORK_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_NETWORKERROR;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.INIT_PUBLISHER_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_CANTSTREAM;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.INVALID_ON_UPDATE_CALLBACK:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_CALLBACK;
            break;

          case OpenTokNetworkConnectivity.ErrorNames.MEDIA_DEVICE_ERROR:
            failedTest.error.message = CrowdHub_App.LANG.OT_ERROR_MEDIADEVICEERROR;
            break;

          // Handle other errors, as needed
          default:
            break;
        }

        failedTest.error.message = failedTest.error.message.replace('*|ERROR|*', failedTest.error.stack);
      });

      let errors = this._errorStringForFailure(results.failedTests);
      this.mDiv.find('.test_result_text').html(`${CrowdHub_App.LANG.TESTING_FAILED}<br><br>${errors}`);
    }

    setTimeout(() => {
      this.mDiv.find('.test_results').hide();
      this.mDiv.find('.test_progress').hide();
      this.mDiv.find('.test_prompt').show();
      this.mDiv.find('.start_container').show();
    }, 5000);
  }

  private _errorStringForFailure(failedTests): string {
    var errors = '';
    $.each(failedTests, function (index, failedTest) {
      errors += failedTest.error.message + '<br/>';
    });

    return errors;
  }

  private _getStruct(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        style: 'choosedevices_panel ui_screen panel',
        children: [
          {
            style: 'centered_container center_withmargins',
            children: [
              {
                style: 'modal_container',
                children: [
                  {
                    style: 'modal_container_header',
                    children: [
                      {
                        style: 'popup_title',
                        interior: CrowdHub_App.LANG.CHANGE_INPUTS,
                      },
                      {
                        style: 'close_container',
                        role: 'button',
                        tabindex: 0,
                        interior: HGEN.faicon({
                          style: FontAwesomeConfigurations.ICON_XMARK,
                        }),
                      },
                    ],
                  },
                  {
                    style: 'modal_container_body',
                    children: [
                      {
                        style: 'modal_container_body_left_nav',
                        children: [
                          {
                            style: 'modal_container_body_left_nav_item selected',
                            id: 'audio_tab',
                            interior:
                              HGEN.faicon({
                                style: FontAwesomeConfigurations.ICON_SETTINGS_AUDIO_TAB + ' margin_right',
                              }) +
                              HGEN.span({
                                style: '',
                                interior: CrowdHub_App.LANG.SETTINGS_AUDIO_TAB,
                              }),
                          },
                          {
                            style: 'modal_container_body_left_nav_item',
                            id: 'video_tab',
                            interior:
                              HGEN.faicon({
                                style: FontAwesomeConfigurations.ICON_SETTINGS_VIDEO_TAB + ' margin_right',
                              }) +
                              HGEN.span({
                                style: '',
                                interior: CrowdHub_App.LANG.SETTINGS_VIDEO_TAB,
                              }),
                          },
                          {
                            style: 'modal_container_body_left_nav_item',
                            id: 'connectivity_tab',
                            interior:
                              HGEN.faicon({
                                style: FontAwesomeConfigurations.ICON_SETTINGS_CONNECTIVITY_TAB + ' margin_right',
                              }) +
                              HGEN.span({
                                style: '',
                                interior: CrowdHub_App.LANG.SETTINGS_CONNECTIVITY_TAB,
                              }),
                          },
                        ],
                      },
                      {
                        style: 'modal_container_body_main_content',
                        children: [
                          {
                            style: 'connectivity_tab_container',
                            children: [
                              {
                                style: 'tab_container_content',
                                children: [
                                  {
                                    style: 'connection_status',
                                    interior:
                                      HGEN.span({
                                        style: '',
                                        interior: 'Status:',
                                      }) +
                                      HGEN.faicon({
                                        style: `${FontAwesomeConfigurations.ICON_SETTINGS_STATUS_GOOD} connection_icon margin_left margin_right`,
                                      }) +
                                      HGEN.span({
                                        style: 'connection_text',
                                        interior: 'Connected',
                                      }),
                                  },
                                  {
                                    style: 'test_prompt',
                                    children: [
                                      {
                                        style: 'test_title',
                                        interior: CrowdHub_App.LANG.PRETEST_TITLE,
                                      },
                                      {
                                        style: 'test_subtitle',
                                        interior: CrowdHub_App.LANG.PRETEST_SUBTITLE,
                                      },
                                    ],
                                  },
                                  {
                                    style: 'test_progress',
                                    children: [
                                      {
                                        style: 'loader',
                                        interior: HGEN.image({
                                          src: App.INSTANCE.getAssetsSrc(Resources.resources.PRELOADER_ICON.src),
                                          alt: Resources.resources.PRELOADER_ICON,
                                        }),
                                      },
                                      {
                                        style: 'test_title testing',
                                        interior: CrowdHub_App.LANG.TESTING_CONNECTIVITY,
                                      },
                                    ],
                                  },
                                  {
                                    style: 'test_results',
                                    children: [
                                      {
                                        style: 'test_result_text',
                                        interior: 'Connection was successful!',
                                      },
                                    ],
                                  },
                                  {
                                    style: 'start_container',
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            style: 'audio_tab_container',
                            children: [
                              {
                                style: 'tab_container_content',
                                children: [
                                  {
                                    style: 'audio_input_selector_container',
                                    children: [
                                      {
                                        style: 'popup_subtitle',
                                        interior: CrowdHub_App.LANG.CHOOSE_AUDIO_SOURCE,
                                      },
                                      {
                                        style: 'audio_input_selector',
                                      },
                                    ],
                                  },
                                  {
                                    style: 'audio_output_selector_container',
                                    children: [
                                      {
                                        style: 'popup_subtitle',
                                        interior: CrowdHub_App.LANG.CHOOSE_OUTPUT_SOURCE,
                                      },
                                      {
                                        style: 'output_selector',
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            style: 'video_tab_container',
                            children: [
                              {
                                style: 'tab_container_content',
                                children: [
                                  {
                                    style: 'video_input_selector_container',
                                    children: [
                                      {
                                        style: 'popup_subtitle',
                                        interior: CrowdHub_App.LANG.CHOOSE_VIDEO_SOURCE,
                                      },
                                      {
                                        style: 'video_input_selector',
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    style: 'modal_container_footer',
                    children: [{ style: 'buttons_container' }],
                  },
                ],
              },
            ],
          },
        ],
      }),
    );
  }

  private _setupDeviceDropdowns(): void {
    var self = this;
    let allDevices = this.mConstructorParams.deviceList;

    let videoDevices = allDevices.inputs.filter(device => {
      return device.kind == 'videoinput';
    });
    let audioDevices = allDevices.inputs.filter(device => {
      return device.kind == 'audioinput';
    });

    let aListOfVideoDevices = [],
      aListOfAudioDevices = [],
      aListOfOutputDevices = [];
    let audio = '',
      output = '',
      video = '';

    for (var p = 0; p < videoDevices.length; p++) {
      aListOfVideoDevices.push({
        value: videoDevices[p].deviceId,
        name: videoDevices[p].label,
      });
      if (videoDevices[p].deviceId === this.mConstructorParams.chosenVideo) {
        video = this.mConstructorParams.chosenVideo;
      }
    }

    for (var p = 0; p < audioDevices.length; p++) {
      aListOfAudioDevices.push({
        value: audioDevices[p].deviceId,
        name: audioDevices[p].label,
      });
      if (audioDevices[p].deviceId === this.mConstructorParams.chosenAudio) {
        audio = this.mConstructorParams.chosenAudio;
      }
    }

    for (var p = 0; p < allDevices.outputs.length; p++) {
      aListOfOutputDevices.push({
        value: allDevices.outputs[p].deviceId,
        name: allDevices.outputs[p].label,
      });
      if (allDevices.outputs[p].deviceId === this.mConstructorParams.chosenOutput) {
        output = this.mConstructorParams.chosenOutput;
      }
    }

    this.mDiv
      .click(function (e) {
        self.onHide();
        e.stopPropagation();
      })
      .children()
      .click(function (e) {
        return false;
      });

    this.mDiv.find('.video_input_selector').html(
      HGEN.combo({
        id: 'video_input',
        options: aListOfVideoDevices,
        style: 'input',
      }),
    );
    this.mDiv.find('#video_input').val(video).trigger('change');

    this.mDiv.find('.audio_input_selector').html(
      HGEN.combo({
        id: 'audio_input',
        options: aListOfAudioDevices,
        style: 'input',
      }),
    );
    this.mDiv.find('#audio_input').val(audio).trigger('change');

    this.mDiv.find('.output_selector').html(
      HGEN.combo({
        id: 'output_input',
        options: aListOfOutputDevices,
        style: 'input',
      }),
    );
    this.mDiv.find('#output_input').val(output).trigger('change');

    let allOutputs = allDevices.outputs;

    let tempSelect = document.createElement('select');
    tempSelect.classList.add('input');

    for (let i = 0; i !== allOutputs.length; ++i) {
      let deviceInfo = allOutputs[i];
      let option = document.createElement('option');
      option.value = deviceInfo.deviceId;
      if (deviceInfo.kind === 'audiooutput') {
        console.info('Found audio output device: ', deviceInfo.label);
        option.text = deviceInfo.label || `speaker ${tempSelect.length + 1}`;
        tempSelect.appendChild(option);
      } else {
        console.log('Found non audio output device: ', deviceInfo.label);
      }
    }
  }

  setupClickEvents(): void {
    Accessibility.clickAndKeypress(this.mDiv.find('.close_container'), () => {
      this.onHide();
    });
    Accessibility.clickAndKeypress(this.mDiv.find('#connectivity_tab'), event => {
      this.mDiv.find('.modal_container_body_left_nav .selected').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      this.mDiv.find('.video_tab_container').hide();
      this.mDiv.find('.connectivity_tab_container').show();
      this.mDiv.find('.audio_tab_container').hide();
    });
    Accessibility.clickAndKeypress(this.mDiv.find('#audio_tab'), event => {
      this.mDiv.find('.modal_container_body_left_nav .selected').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      this.mDiv.find('.video_tab_container').hide();
      this.mDiv.find('.connectivity_tab_container').hide();
      this.mDiv.find('.audio_tab_container').show();
    });
    Accessibility.clickAndKeypress(this.mDiv.find('#video_tab'), event => {
      this.mDiv.find('.modal_container_body_left_nav .selected').removeClass('selected');
      $(event.currentTarget).addClass('selected');
      this.mDiv.find('.audio_tab_container').hide();
      this.mDiv.find('.connectivity_tab_container').hide();
      this.mDiv.find('.video_tab_container').show();
    });
  }

  setupButtons(): void {
    let aSaveButton = new BaseCSSButton();
    aSaveButton.initialize({
      textStyle: '',
      buttonStyle: 'standard_button_filled',
      text: CrowdHub_App.LANG.SAVE_INPUTS_BUTTON,
      click: this.onSave.bind(this),
      scope: this,
      showLoader: true,
      container: this.mDiv.find('.buttons_container'),
    });

    let aStartButton = new BaseCSSButton();
    aStartButton.initialize({
      textStyle: '',
      buttonStyle: 'standard_button_filled',
      text: CrowdHub_App.LANG.PRETEST_BUTTON,
      click: () => {
        this.mDiv.find('.test_prompt').hide();
        this.mDiv.find('.start_container').hide();
        this.mDiv.find('.test_progress').show();
        this.mConstructorParams
          .onRunTest()
          .then(results => {
            this._onTestCompleted(results);
          })
          .catch(error => {
            console.error(error);
          });
      },
      scope: this,
      showLoader: false,
      container: this.mDiv.find('.start_container'),
    });
  }

  onSave(): void {
    var aVideoVal = this.mDiv.find('#video_input').val();
    var aAudioVal = this.mDiv.find('#audio_input').val();
    var aOutputVal = this.mDiv.find('#output_input').val();

    if (typeof this.mConstructorParams.onSave === 'function') {
      this.mConstructorParams.onSave({
        videoDeviceId: aVideoVal,
        audioDeviceId: aAudioVal,
        outputDeviceId: aOutputVal,
      });
    }
  }

  onResize(_aWidth, _aHeight): void {}

  onHide(): void {
    if (typeof this.mConstructorParams.onHide === 'function') {
      this.mConstructorParams.onHide();
    }
  }

  onTransitionIn(): void {
    this.setupClickEvents();

    this.mDiv.find('.connectivity_tab_container').hide();
    this.mDiv.find('.video_tab_container').hide();

    if (this.mConstructorParams.chosenTab) {
      this.mDiv.find('#' + this.mConstructorParams.chosenTab).trigger('click');
    }
  }

  onTransitionInComplete(): void {}

  onTransitionOut(): void {}
}
